import type { FC } from 'react';

export const Divider: FC = () => <hr className="my-4 border-white/10" />;
